import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/ff`;
const ck = "ff_draft_2729";

const Bar = ({ label, n, perc, color }) => (
  <div className="mb-2" data-testid="ff-bar">
    <div className="flex justify-between text-sm"><span className="pr-2">{label}</span><span className="text-slate-500 whitespace-nowrap">{n} · {perc}%</span></div>
    <div className="h-2 rounded bg-slate-100"><div className="h-2 rounded" style={{ width: `${perc}%`, background: color }} /></div>
  </div>
);

export default function FFPublic() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [step, setStep] = useState(0); // 0=welcome,1-4=steps,5=review,6=thanks
  const [f, setF] = useState(() => { try { return JSON.parse(localStorage.getItem(ck)) || {}; } catch { return {}; } });
  const [already, setAlready] = useState(!!localStorage.getItem("ff_done_2729"));
  const color = data?.config?.colore || "#2563EB";

  useEffect(() => { axios.get(`${API}/public/survey`).then((r) => setData(r.data)).catch(() => setErr("Errore di caricamento")); }, []);
  useEffect(() => { localStorage.setItem(ck, JSON.stringify(f)); }, [f]);

  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const toggle = (k, opt, max) => setF((p) => {
    const arr = p[k] || [];
    if (arr.includes(opt)) return { ...p, [k]: arr.filter((x) => x !== opt) };
    if (max && arr.length >= max) return p;
    return { ...p, [k]: [...arr, opt] };
  });

  if (err) return <Shell color={color}><p className="text-red-600">{err}</p></Shell>;
  if (!data) return <Shell color={color}><p>Caricamento…</p></Shell>;
  if (!data.aperto) return <Shell color={color}><h2 className="text-xl font-semibold">La rilevazione è conclusa.</h2><p className="text-slate-600 mt-2">Grazie per l'interesse.</p></Shell>;

  const Q = data.questions;
  const submit = async () => {
    try {
      await axios.post(`${API}/public/submit`, {
        d1_ruolo: f.d1_ruolo, d1_altro: f.d1_altro || "", d2: f.d2 || [], d3: f.d3 || {},
        d4: f.d4 || [], d4_altro: f.d4_altro || "", d5: f.d5 || [], d5_altro: f.d5_altro || "",
        d6a: f.d6a, d6b: f.d6b || [], d6c: f.d6c, d7: f.d7 || "", d8: f.d8 || "",
      });
      localStorage.removeItem(ck); localStorage.setItem("ff_done_2729", "1"); setStep(6);
    } catch (e) { setErr(e.response?.data?.detail || "Invio non riuscito"); window.scrollTo(0, 0); }
  };

  const canNext = () => {
    if (step === 1) return f.d1_ruolo && (f.d1_ruolo !== "Altro" || (f.d1_altro || "").trim());
    if (step === 2) return (f.d2 || []).length >= 1 && (f.d4 || []).length >= 1 && Q.d3.every((t) => (f.d3 || {})[t]);
    if (step === 3) return f.d6a && (f.d6b || []).length >= 1 && f.d6c;
    return true;
  };

  return (
    <Shell color={color} logo={data.config.logo_url} title={data.config.titolo}>
      {step === 0 && (
        <div data-testid="ff-welcome">
          <p className="text-slate-700 whitespace-pre-line">{data.config.intro}</p>
          <p className="text-sm text-slate-500 mt-3">Scadenza: {data.config.data_scadenza}</p>
          {already && <p className="text-amber-600 text-sm mt-2">Risulta che hai già compilato da questo dispositivo. Puoi comunque procedere.</p>}
          <button onClick={() => setStep(1)} style={{ background: color }} className="mt-5 text-white px-6 py-2.5 rounded-lg" data-testid="ff-start">Inizia</button>
        </div>
      )}
      {step >= 1 && step <= 4 && <Progress step={step} color={color} />}
      {err && step >= 1 && <p className="text-red-600 text-sm mb-3" data-testid="ff-err">{err}</p>}

      {step === 1 && (
        <div data-testid="ff-step1">
          <h3 className="font-semibold mb-2">D1. Ruolo / professione *</h3>
          {Q.ruoli.map((r) => (
            <label key={r} className="flex items-start gap-2 py-1.5 cursor-pointer"><input type="radio" name="d1" checked={f.d1_ruolo === r} onChange={() => set("d1_ruolo", r)} /> <span>{r}</span></label>
          ))}
          {f.d1_ruolo === "Altro" && <input maxLength={100} value={f.d1_altro || ""} onChange={(e) => set("d1_altro", e.target.value)} placeholder="Specifica" className="border rounded p-2 w-full mt-1" data-testid="ff-d1-altro" />}
        </div>
      )}
      {step === 2 && (
        <div data-testid="ff-step2" className="space-y-6">
          <MultiQ title="D2. Competenze relazionali e supporto alla famiglia *" desc="Scegli da 1 a 2 opzioni: le aree relazionali su cui senti più bisogno di formazione." opts={Q.d2} sel={f.d2 || []} onT={(o) => toggle("d2", o, 2)} min={1} max={2} />
          <div>
            <h3 className="font-semibold mb-1">D3. Quadro normativo e Terzo Settore *</h3>
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs text-slate-500">Rispondi a <b>ogni</b> argomento indicando quanto è prioritario per te.</p>
              <span className={`text-xs font-medium ${Q.d3.every((t) => (f.d3 || {})[t]) ? "text-green-600" : "text-slate-400"}`} data-testid="ff-d3-counter">Valutati: {Q.d3.filter((t) => (f.d3 || {})[t]).length}/{Q.d3.length}</span>
            </div>
            {Q.d3.map((t) => (
              <div key={t} className="mb-2 border-b border-slate-100 pb-2"><div className="text-sm">{t}</div>
                <div className="flex flex-wrap gap-3 mt-1">{Q.d3_val.map((v) => (
                  <label key={v} className="text-sm flex items-center gap-1"><input type="radio" name={t} checked={(f.d3 || {})[t] === v} onChange={() => set("d3", { ...(f.d3 || {}), [t]: v })} />{v}</label>
                ))}</div>
              </div>
            ))}
          </div>
          <MultiQ title="D4. Competenze professionali *" desc="Scegli da 1 a 3 opzioni: le competenze tecnico-professionali più utili al tuo lavoro." opts={Q.d4} sel={f.d4 || []} onT={(o) => toggle("d4", o, 3)} min={1} max={3} altro={f.d4_altro} onAltro={(v) => set("d4_altro", v)} altroLen={150} />
          <MultiQ title="D5. Formazione amministrativa e tecnica" desc="Facoltativa. Puoi scegliere fino a 3 opzioni (oppure nessuna)." opts={Q.d5} sel={f.d5 || []} onT={(o) => toggle("d5", o, 3)} max={3} altro={f.d5_altro} onAltro={(v) => set("d5_altro", v)} altroLen={150} />
        </div>
      )}
      {step === 3 && (
        <div data-testid="ff-step3" className="space-y-5">
          <SingleQ title="D6a. Modalità *" desc="Scegli una sola opzione: come preferiresti seguire la formazione." opts={Q.d6a} val={f.d6a} onC={(o) => set("d6a", o)} />
          <MultiQ title="D6b. Metodologia *" desc="Seleziona almeno una metodologia (puoi indicarne anche più di una)." opts={Q.d6b} sel={f.d6b || []} onT={(o) => toggle("d6b", o)} />
          <SingleQ title="D6c. Tempi *" desc="Scegli una sola opzione: quando saresti disponibile." opts={Q.d6c} val={f.d6c} onC={(o) => set("d6c", o)} />
        </div>
      )}
      {step === 4 && (
        <div data-testid="ff-step4" className="space-y-4">
          <TextQ title="D7. Tematica emergente nel tuo lavoro" help="Descrivi la principale sfida professionale per cui ti serve formazione." val={f.d7 || ""} onC={(v) => set("d7", v)} />
          <TextQ title="D8. Suggerimenti per migliorare l'organizzazione" help="Spazio libero per proposte. Evita di inserire nomi di persone." val={f.d8 || ""} onC={(v) => set("d8", v)} />
        </div>
      )}
      {step === 5 && (
        <div data-testid="ff-review">
          <h3 className="font-semibold mb-2">Riepilogo</h3>
          <ul className="text-sm text-slate-700 space-y-1">
            <li><b>Ruolo:</b> {f.d1_ruolo}{f.d1_altro ? ` (${f.d1_altro})` : ""}</li>
            <li><b>D2:</b> {(f.d2 || []).join(", ")}</li>
            <li><b>D4:</b> {(f.d4 || []).join(", ")}</li>
            <li><b>D6:</b> {f.d6a} · {(f.d6b || []).join(", ")} · {f.d6c}</li>
          </ul>
          <button onClick={() => setStep(1)} className="mt-3 mr-2 border px-4 py-2 rounded-lg">Modifica</button>
          <button onClick={submit} style={{ background: color }} className="mt-3 text-white px-6 py-2 rounded-lg" data-testid="ff-submit">Invia</button>
        </div>
      )}
      {step === 6 && <div data-testid="ff-thanks"><h2 className="text-xl font-semibold">Grazie!</h2><p className="text-slate-600 mt-2">La tua risposta anonima è stata registrata.</p></div>}

      {step >= 1 && step <= 5 && (
        <div className="flex justify-between mt-6">
          <button onClick={() => setStep(step - 1)} className="border px-4 py-2 rounded-lg" data-testid="ff-back">Indietro</button>
          {step < 5
            ? <button disabled={!canNext()} onClick={() => { setErr(""); setStep(step + 1); }} style={{ background: canNext() ? color : "#cbd5e1" }} className="text-white px-6 py-2 rounded-lg" data-testid="ff-next">Avanti</button>
            : null}
        </div>
      )}
    </Shell>
  );
}

const Shell = ({ children, color, logo, title }) => (
  <div className="min-h-screen bg-slate-50 py-8 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl border p-6 sm:p-8" style={{ fontSize: 16 }}>
      {logo ? <img src={logo} alt="logo" className="h-14 w-auto max-w-full mb-4" /> : null}
      {title && <h1 className="text-2xl font-bold mb-4" style={{ color }}>{title}</h1>}
      {children}
    </div>
  </div>
);
const Progress = ({ step, color }) => (
  <div className="mb-4"><div className="text-sm text-slate-500 mb-1">{step}/4</div><div className="h-1.5 bg-slate-100 rounded"><div className="h-1.5 rounded" style={{ width: `${(step / 4) * 100}%`, background: color }} /></div></div>
);
const MultiQ = ({ title, desc, opts, sel, onT, min, max, altro, onAltro, altroLen }) => {
  const count = sel.length;
  const instr = desc || (max ? (min ? `Scegli da ${min} a ${max} opzioni.` : `Scegli fino a ${max} opzioni.`) : "Seleziona una o più opzioni.");
  return (
    <div><h3 className="font-semibold mb-1">{title}</h3>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-slate-500">{instr}</p>
        {max ? <span className={`text-xs font-medium ${count >= max ? "text-amber-600" : "text-slate-400"}`} data-testid="ff-multi-counter">Selezionate: {count}/{max}</span> : null}
      </div>
      {opts.map((o) => {
        const dis = max && !sel.includes(o) && sel.length >= max;
        return <label key={o} className={`flex items-start gap-2 py-1 ${dis ? "opacity-40" : "cursor-pointer"}`}><input type="checkbox" checked={sel.includes(o)} disabled={dis} onChange={() => onT(o)} /><span className="text-sm">{o}</span></label>;
      })}
      {max && sel.length >= max && <p className="text-xs text-amber-600 mt-1">Hai raggiunto il massimo di {max} opzioni. Per cambiarne una, deselezionane prima un'altra.</p>}
      {onAltro !== undefined && sel.includes("Altro") && <input maxLength={altroLen} value={altro || ""} onChange={(e) => onAltro(e.target.value)} placeholder="Specifica (Altro)" className="border rounded p-2 w-full mt-1" />}
    </div>
  );
};
const SingleQ = ({ title, desc, opts, val, onC }) => (
  <div><h3 className="font-semibold mb-1">{title}</h3><p className="text-xs text-slate-500 mb-2">{desc || "Scegli una sola opzione."}</p>{opts.map((o) => <label key={o} className="flex items-center gap-2 py-1 cursor-pointer"><input type="radio" checked={val === o} onChange={() => onC(o)} /><span className="text-sm">{o}</span></label>)}</div>
);
const TextQ = ({ title, help, val, onC }) => (
  <div><h3 className="font-semibold">{title}</h3><p className="text-xs text-slate-500 mb-1">{help}</p>
    <textarea maxLength={1500} rows={4} value={val} onChange={(e) => onC(e.target.value)} className="border rounded p-2 w-full" />
    <div className="text-xs text-slate-400 text-right">{val.length}/1500</div></div>
);
export { Bar };
